export const KilnValidationErrorImage: React.FC = () => {
  return (
    <svg
      width="240"
      height="195"
      viewBox="0 0 240 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M77.9375 88.3267H72.2217V86.0527H77.9375C78.6922 86.0527 79.416 85.7541 79.9496 85.2226C80.4833 84.691 80.7831 83.9701 80.7831 83.2184C80.7831 82.4667 80.4833 81.7458 79.9496 81.2143C79.416 80.6827 78.6922 80.3841 77.9375 80.3841H72.2217V78.1101H77.9375C79.2977 78.1101 80.6022 78.6483 81.564 79.6063C82.5258 80.5643 83.0661 81.8636 83.0661 83.2184C83.0661 84.5732 82.5258 85.8725 81.564 86.8305C80.6022 87.7885 79.2977 88.3267 77.9375 88.3267Z"
        fill="#016AD4"
      />
      <path
        opacity="0.61"
        d="M77.9375 88.3267H72.2217V86.0527H77.9375C78.6922 86.0527 79.416 85.7541 79.9496 85.2226C80.4833 84.691 80.7831 83.9701 80.7831 83.2184C80.7831 82.4667 80.4833 81.7458 79.9496 81.2143C79.416 80.6827 78.6922 80.3841 77.9375 80.3841H72.2217V78.1101H77.9375C79.2977 78.1101 80.6022 78.6483 81.564 79.6063C82.5258 80.5643 83.0661 81.8636 83.0661 83.2184C83.0661 84.5732 82.5258 85.8725 81.564 86.8305C80.6022 87.7885 79.2977 88.3267 77.9375 88.3267Z"
        fill="white"
      />
      <path
        opacity="0.15"
        d="M120 195C186.274 195 240 187.556 240 178.374C240 169.191 186.274 161.747 120 161.747C53.7258 161.747 0 169.191 0 178.374C0 187.556 53.7258 195 120 195Z"
        fill="#C9D3DB"
      />
      <path
        d="M194.604 45.4171C193.479 62.7772 185.157 106.066 128.9 81.7191L130.836 76.0011C130.836 76.0011 158.638 80.887 165.991 70.6127C172.212 61.912 172.113 33.3796 185.844 34.7391C188.405 35.0498 190.746 36.3344 192.379 38.3243C194.011 40.3142 194.808 42.8555 194.604 45.4171Z"
        fill="#016AD4"
      />
      <path
        opacity="0.08"
        d="M194.604 45.4171C193.479 62.7772 185.157 106.066 128.9 81.7191L130.836 76.0011C130.836 76.0011 158.638 80.887 165.991 70.6127C172.212 61.912 172.113 33.3796 185.844 34.7391C188.405 35.0498 190.746 36.3344 192.379 38.3243C194.011 40.3142 194.808 42.8555 194.604 45.4171Z"
        fill="#29333D"
      />
      <path
        d="M142.822 13.0697C142.822 13.0697 143.964 19.3233 146.131 23.1051C146.339 23.4715 146.617 23.7933 146.951 24.0519C147.284 24.3105 147.665 24.5008 148.073 24.6119C148.481 24.723 148.906 24.7526 149.325 24.699C149.744 24.6454 150.149 24.5097 150.515 24.2998C152.417 23.1957 154.651 21.1606 154.452 17.7084L154.825 11.8503C154.776 10.6705 154.361 9.53477 153.637 8.60036C152.912 7.66594 151.914 6.97908 150.78 6.63487C146.602 5.11886 141.937 9.29614 142.822 13.0697Z"
        fill="#F4A28C"
      />
      <path
        d="M154.874 13.7783L167.257 26.2278L159.862 34.2281L152.095 19.348L154.874 13.7783Z"
        fill="#F4A28C"
      />
      <path
        d="M150.805 16.5467C150.805 16.5467 150.201 14.1738 152.029 13.869C153.857 13.5641 154.75 16.9916 152.418 17.9886L150.805 16.5467Z"
        fill="#F4A28C"
      />
      <path
        d="M143.749 16.9756L142.698 19.8016C142.638 19.9619 142.62 20.1346 142.644 20.304C142.669 20.4733 142.735 20.6338 142.838 20.7707C142.941 20.9077 143.077 21.0167 143.233 21.0878C143.389 21.1589 143.561 21.1897 143.732 21.1776L146.214 20.9798L143.749 16.9756Z"
        fill="#F4A28C"
      />
      <path
        d="M175.132 171.617C175.132 171.617 173.478 174.624 170.558 174.427C167.638 174.229 166.422 176.898 168.903 178.06C171.385 179.222 178.615 176.89 178.615 176.89L179.07 172.705L175.132 171.617Z"
        fill="#016AD4"
      />
      <path
        d="M209.989 167.786C209.989 167.786 211.851 170.678 210.254 173.133C208.658 175.589 210.469 177.937 212.661 176.314C214.853 174.691 216.326 167.251 216.326 167.251L212.86 164.836L209.989 167.786Z"
        fill="#016AD4"
      />
      <path
        opacity="0.31"
        d="M153.344 21.7378C153.923 20.4654 154.289 19.1072 154.427 17.717C154.427 17.717 159.242 22.1497 156.016 26.8626L153.344 21.7378Z"
        fill="#CE8172"
      />
      <path
        d="M173.685 106.989L173.329 172.977H181.899L192.867 106.14L173.685 106.989Z"
        fill="#29333D"
      />
      <path
        d="M161.235 29.6308C165.545 26.1952 170.863 24.2541 176.381 24.1022C185.314 24.0116 210.229 25.5359 208.525 55.8891C207.26 78.3822 206.614 103.265 206.614 103.265L173.808 108.711C173.808 108.711 134.624 53.4833 161.235 29.6308Z"
        fill="#016AD4"
      />
      <path
        opacity="0.08"
        d="M182.915 37.26C182.915 37.26 176.042 45.4992 180.293 60.5605C184.545 75.6218 190.517 93.7893 170.036 102.918L173.808 108.686L206.614 103.24L207.044 89.3319L212.314 63.5761L182.915 37.26Z"
        fill="#29333D"
      />
      <path opacity="0.79" d="M101.521 90.4773H46.124V178.373H101.521V90.4773Z" fill="#668099" />
      <path d="M118.222 90.4773H70.3027V178.373H118.222V90.4773Z" fill="#E8ECF0" />
      <path
        d="M104.482 95.6184L103.605 100.653H80.0801V121.893H119.206V104.591V100.653V95.6184H104.482Z"
        fill="#EE8B00"
      />
      <path
        opacity="0.08"
        d="M104.482 95.6184L103.605 100.653H80.0801V121.893H119.206V104.591V100.653V95.6184H104.482Z"
        fill="#29333D"
      />
      <path
        d="M110.198 95.6184L109.321 100.653H85.7959V121.893H124.922V104.591V100.653V95.6184H110.198Z"
        fill="#EE8B00"
      />
      <path
        d="M173.287 66.3855L174.892 72.326L153.27 81.5621L163.436 105.167L199.402 89.8013L191.122 70.5793L189.236 66.196L186.82 60.6016L173.287 66.3855Z"
        fill="#EE8B00"
      />
      <path
        opacity="0.08"
        d="M173.287 66.3855L174.892 72.326L153.27 81.5621L163.436 105.167L199.402 89.8013L191.122 70.5793L189.236 66.196L186.82 60.6016L173.287 66.3855Z"
        fill="#29333D"
      />
      <path
        d="M178.54 64.137L180.145 70.0857L158.522 79.3136L168.689 102.919L204.646 87.5611L196.375 68.3308L194.489 63.9558L192.073 58.3613L178.54 64.137Z"
        fill="#EE8B00"
      />
      <path
        d="M114.921 95.6184L114.044 100.653H90.5273V121.893H129.653V104.591V100.653V95.6184H114.921Z"
        fill="#EE8B00"
      />
      <path
        opacity="0.08"
        d="M114.921 95.6184L114.044 100.653H90.5273V121.893H129.653V104.591V100.653V95.6184H114.921Z"
        fill="#29333D"
      />
      <path
        d="M126.641 88.984L89.8789 94.3127L93.5181 119.221L130.28 113.892L126.641 88.984Z"
        fill="#29333D"
      />
      <path
        opacity="0.12"
        d="M126.641 88.984L89.8789 94.3127L93.5181 119.221L130.28 113.892L126.641 88.984Z"
        fill="white"
      />
      <path
        d="M128.569 85.4161L91.8076 90.7449L95.4469 115.653L132.209 110.325L128.569 85.4161Z"
        fill="#29333D"
      />
      <path
        d="M120.637 95.6184L119.76 100.653H96.2432V121.893H135.369V104.591V100.653V95.6184H120.637Z"
        fill="#EE8B00"
      />
      <path d="M139.546 107.006H77.8877V130.982H139.546V107.006Z" fill="#668099" />
      <path
        opacity="0.08"
        d="M196.573 68.7993C192.942 73.4594 189.077 77.9335 184.992 82.2045C181.859 85.3588 178.338 88.105 174.512 90.3778C172.287 91.7373 169.946 94.1596 171.517 97.9497H183.768L199.774 76.3217L196.573 68.7993Z"
        fill="#29333D"
      />
      <path d="M139.538 107.006H97.335V130.982H139.538V107.006Z" fill="#E8ECF0" />
      <path d="M126.708 142.063H77.8877V166.039H126.708V142.063Z" fill="#E8ECF0" />
      <path d="M75.9194 75.6379H61.9482V90.7981H75.9194V75.6379Z" fill="#016AD4" />
      <path
        d="M119.181 121.399C121.05 121.399 122.564 119.89 122.564 118.029C122.564 116.168 121.05 114.659 119.181 114.659C117.313 114.659 115.798 116.168 115.798 118.029C115.798 119.89 117.313 121.399 119.181 121.399Z"
        fill="#8599AD"
      />
      <path
        d="M103.026 156.465C104.894 156.465 106.409 154.957 106.409 153.095C106.409 151.234 104.894 149.726 103.026 149.726C101.157 149.726 99.6426 151.234 99.6426 153.095C99.6426 154.957 101.157 156.465 103.026 156.465Z"
        fill="#8599AD"
      />
      <path
        d="M130.481 77.0391C128.158 76.9478 125.84 77.2973 123.648 78.069C119.984 79.3543 116.592 82.6088 119.206 86.4153C121.225 89.3485 124.087 87.8325 125.154 85.4843C126.221 83.1361 126.866 80.8621 128.901 81.719L130.481 77.0391Z"
        fill="#F4A28C"
      />
      <path
        d="M194.38 28.0405C199.656 30.0045 204.491 32.9863 208.607 36.815C212.724 40.6437 216.041 45.2441 218.369 50.3523C220.41 54.6571 221.392 59.384 221.236 64.142C221.079 68.9 219.787 73.5525 217.467 77.7148C212.612 86.1682 202.661 95.6515 182.254 99.7547L179.88 93.8142L199.368 76.7672C200.407 75.8616 201.248 74.753 201.839 73.5101C202.43 72.2672 202.758 70.9167 202.803 69.5422C202.848 68.1678 202.609 66.7988 202.101 65.5202C201.592 64.2416 200.826 63.0808 199.848 62.1097C194.058 56.3422 186.696 47.8558 183.379 38.8998C182.818 37.3742 182.709 35.7205 183.064 34.135C183.42 32.5494 184.224 31.0988 185.383 29.9553C186.541 28.8118 188.005 28.0235 189.6 27.6841C191.195 27.3447 192.854 27.4684 194.38 28.0405Z"
        fill="#016AD4"
      />
      <path
        opacity="0.2"
        d="M194.38 28.0405C199.656 30.0045 204.491 32.9863 208.607 36.815C212.724 40.6437 216.041 45.2441 218.369 50.3523C220.41 54.6571 221.392 59.384 221.236 64.142C221.079 68.9 219.787 73.5525 217.467 77.7148C212.612 86.1682 202.661 95.6515 182.254 99.7547L179.88 93.8142L199.368 76.7672C200.407 75.8616 201.248 74.753 201.839 73.5101C202.43 72.2672 202.758 70.9167 202.803 69.5422C202.848 68.1678 202.609 66.7988 202.101 65.5202C201.592 64.2416 200.826 63.0808 199.848 62.1097C194.058 56.3422 186.696 47.8558 183.379 38.8998C182.818 37.3742 182.709 35.7205 183.064 34.135C183.42 32.5494 184.224 31.0988 185.383 29.9553C186.541 28.8118 188.005 28.0235 189.6 27.6841C191.195 27.3447 192.854 27.4684 194.38 28.0405Z"
        fill="white"
      />
      <path
        d="M180.293 94.9186C180.293 94.9186 171.194 93.9299 170.367 97.3903C169.54 100.851 168.978 102.944 168.978 102.944C173.581 102.838 178.065 101.464 181.931 98.9723L180.293 94.9186Z"
        fill="#F4A28C"
      />
      <path
        d="M206.615 103.264C206.976 107.479 207.026 111.714 206.764 115.936C206.54 121.135 205.184 129.795 204.158 135.785C203.427 140.117 204.216 144.569 206.391 148.391L214.663 163.048L208.658 169.013L198.806 156.259C193.776 149.715 190.334 142.102 188.748 134.013L185.613 118.079L177.713 108.076L206.615 103.264Z"
        fill="#29333D"
      />
      <path
        d="M139.182 5.62994C139.182 5.62994 136.626 11.5127 142.731 11.8011C148.836 12.0895 148.761 10.8536 148.761 10.8536C148.761 10.8536 149.142 18.7138 154.427 17.7334L156.619 15.5252C156.619 15.5252 159.101 5.49811 154.8 3.29824C154.8 3.29824 146.213 -5.493 139.182 5.62994Z"
        fill="#29333D"
      />
      <path
        d="M150.705 17.4943C150.705 17.4943 151.028 12.3695 153.923 13.6465C156.818 14.9236 154.907 20.5098 150.705 17.4943Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.45"
        d="M72.2217 75.6383C72.2217 75.6383 82.0569 69.3518 72.2217 60.5606C62.3864 51.7693 58.5317 72.0955 51.36 58.3607C44.1883 44.6259 62.3864 29.8036 42.261 28.6995C22.1355 27.5955 34.7253 14.9318 17.3957 13.4405C0.066168 11.9492 -4.61571 42.5249 8.61928 44.5435C21.8543 46.5621 34.5433 47.3778 30.9533 60.0085C27.3633 72.6393 40.8796 76.075 47.2241 72.9853C53.5686 69.8956 61.948 75.6383 61.948 75.6383H72.2217Z"
        fill="#E8ECF0"
      />
      <path
        opacity="0.58"
        d="M36.818 166.022C36.818 166.022 27.0159 163.402 24.8486 154.339C24.8486 154.339 40.0027 151.225 40.499 166.813L36.818 166.022Z"
        fill="#009D93"
      />
      <path
        opacity="0.73"
        d="M38.026 165.017C38.026 165.017 31.1438 154.306 37.1161 144.189C37.1161 144.189 48.6967 151.431 43.6178 165.017H38.026Z"
        fill="#009D93"
      />
      <path
        d="M39.7881 165.018C39.7881 165.018 43.3533 153.631 54.2639 151.431C54.2639 151.431 56.3484 158.846 47.2493 165.018H39.7881Z"
        fill="#009D93"
      />
      <path d="M32.6904 164.795L34.7336 178.307H47.2241L49.0108 164.795H32.6904Z" fill="#29333D" />
    </svg>
  )
}
